import { datadogRum } from '@datadog/browser-rum'

const ANIME_AWARDS_YEAR = 2027

const ALLOWED_CONTEXT_KEYS = new Set([
  'award_year',
  'route',
  'locale',
  'vote_type',
  'environment',
  // Storyblok fetch context
  'request_count',
  'fulfilled_request_count',
  'rejected_request_count',
  'story_count',
  'relation_count',
  'has_cv',
  'response_status',
  // Storyblok/category hydration context
  'cache_hit',
  'hydration_status',
  // Vote-page readiness context
  'has_content_header',
  'has_categories',
  'vote_state',
  // Sanitized failure metadata
  'error_type',
])

export const sanitizeContext = (context = {}) =>
  Object.entries(context).reduce((safeContext, [key, value]) => {
    if (!ALLOWED_CONTEXT_KEYS.has(key)) return safeContext

    if (typeof value === 'boolean') safeContext[key] = value
    else if (typeof value === 'number' && Number.isFinite(value)) {
      safeContext[key] = value
    } else if (typeof value === 'string') {
      safeContext[key] = value.slice(0, 80)
    }

    return safeContext
  }, {})

export const createAnimeAwardsObservability = (rum) => {
  const track = (eventName, context = {}) => {
    if (!rum?.addAction) return

    try {
      rum.addAction(
        eventName,
        sanitizeContext({
          ...context,
          award_year: ANIME_AWARDS_YEAR,
        })
      )
    } catch {
      // Observability must never affect the voting experience.
    }
  }

  return {
    track,
    failure: (eventName, error, context = {}) =>
      track(eventName, {
        ...context,
        error_type: error?.name || 'Error',
      }),
  }
}

const getAnimeAwardsObservability = () =>
  createAnimeAwardsObservability(
    typeof window === 'undefined' ? null : datadogRum
  )

export const trackAnimeAwardsEvent = (eventName, context = {}) =>
  getAnimeAwardsObservability().track(eventName, context)

export const trackAnimeAwardsFailure = (eventName, error, context = {}) =>
  getAnimeAwardsObservability().failure(eventName, error, context)
